export const blockIconsPhotoandimageTuneNew = (
	<span className='material-symbols-outlined'>tune</span>
);
